import { ReactElement, ReactNode, useRef, useState } from 'react'

import Modal from '@mui/material/Modal'
import { BoxProps } from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import Typograhpy from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import Divider from '@mui/material/Divider'
import Slide from '@mui/material/Slide'

import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

import { CancelButton, ConfirmButton, DeleteButton, SaveButton } from '../Button'
import { IAppModal } from '../../../compiler/global.interface'
import { DisabledByDefault } from '@mui/icons-material'

export interface IAppModalProps extends IAppModal{
    onDeny?: (...rest:any)=> any,
    onSave?: (...rest:any)=> any,
    onConfirm?: (...rest:any)=> any,
    onCancel?: (...rest:any)=> any,
    onDelete?:(...rest:any)=> any,
    onNextStep?:(...rest:any)=> any,
    onPreviousStep?:(...rest:any)=> any;
    disabled?:{
        all?:boolean,
        onCancel?:boolean,
        onConfirm?:boolean,
        onDelete?:boolean,
        onSave?:boolean
    }
    children?: ReactElement
}

export default function AppModal({ prefix, title, open = false, loading, stepConfig, onCancel, onSave, onConfirm, onDeny, onNextStep, onDelete, children, sx, onClose, disabled, ...rest }: IAppModalProps & BoxProps): ReactElement {
    const [cooldown,setCooldown] = useState(false)

    const timeoutRef: { current: NodeJS.Timeout | null } = useRef(null)

    const handleClose = () => {
        onClose?.()
    };

    const handleCancel = () => {
        onCancel?.()
    }

    const handleNextStep = () => {
        onNextStep?.()
        setCooldown(true)
        timeoutRef.current && clearTimeout(timeoutRef.current)
        timeoutRef.current = setTimeout(()=>{
            setCooldown(false)
        },500)
    }

    const handleDeny = () => {
        onDeny?.()
    }

    const handleDelete = () => {
        onDelete?.()
    }

    const handleSave = () => {
        onSave?.()
    }

    const handleConfirm = () => {
        onConfirm?.()
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
        >
            <Paper sx={{
                outline:'none',
                position: 'absolute' as 'absolute',
                top: '50%',
                left: '50%',
                overflowX:'hidden',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper',
                width: { xs: '100%', sm: 600 },
                ...sx,
            }}>
                <Stack>
                    <Stack pl={3} pr={3} py={2} direction={'row'} alignItems={'center'}>
                        <Typograhpy color={'primary.dark'} variant='h6' sx={{ flex: 1 }}>{prefix} {title}</Typograhpy>
                        <IconButton onClick={handleClose} sx={{ flex: 0, p: 1 }}>
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                    <Divider />
                    <Stack overflow={'auto'} px={3} py={3} maxHeight={480} className="App_modal__container">
                        {children && (
                            <Slide direction="left" {...!stepConfig && { timeout: 0 }} in={!cooldown}>
                                {children}
                            </Slide>
                        )}
                    </Stack>
                    <Divider />
                    {(onConfirm || onCancel || onDelete || onSave) && (
                        <Stack sx={{
                            opacity: cooldown || loading ? 0.4 : 1,
                            pointerEvents: cooldown || loading ? 'none' : 'auto'
                        }} px={3} py={2} direction={'row'} justifyContent={'flex-end'} alignItems={'center'} spacing={2}>
                            {onDelete && (<DeleteButton disabled={loading || disabled?.onDelete || disabled?.all} sx={{ mr: 'auto' }} startIcon={<DeleteOutlineOutlinedIcon />} onClick={handleDelete}>ลบ</DeleteButton>)}
                            {onCancel && (<CancelButton disabled={loading || disabled?.onCancel || disabled?.all} onClick={handleCancel}>ยกเลิก</CancelButton>)}
                            {onSave && (<SaveButton loading={loading} disabled={loading || disabled?.onSave || disabled?.all} onClick={handleSave}>บันทึก</SaveButton>)}
                            {stepConfig?.[0] === stepConfig?.[1] && onConfirm ? <ConfirmButton loading={loading} disabled={loading || disabled?.onConfirm || disabled?.all} onClick={handleConfirm}>ยืนยัน</ConfirmButton> : onConfirm ? <ConfirmButton loading={loading} disabled={loading || disabled?.onConfirm || disabled?.all } onClick={handleNextStep}>ถัดไป</ConfirmButton> : <></>}
                        </Stack>
                    )}
                </Stack>
            </Paper>
        </Modal>
    );
}

